export default __webpack_public_path__ + "static/media/box-view.09b11651.svg";